import { render, staticRenderFns } from "./Operator-Detail.vue?vue&type=template&id=1c77839c&"
import script from "./Operator-Detail.vue?vue&type=script&lang=ts&"
export * from "./Operator-Detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports